module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_09.96094ac4.svg";